import { render, staticRenderFns } from "./RuleInput.vue?vue&type=template&id=4f05722a&scoped=true"
import script from "./RuleInput.vue?vue&type=script&lang=js"
export * from "./RuleInput.vue?vue&type=script&lang=js"
import style0 from "./RuleInput.vue?vue&type=style&index=0&id=4f05722a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f05722a",
  null
  
)

export default component.exports